// Theme: studio-ink
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'studio-ink',
  name: 'STUDIO INK',
  tagline: 'STUDIO INK',
  description: 'Azul de tinta de estudio com base fria e legivel.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#101418', '#1A2030', '#38BDF8', '#DBEAFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-studio-ink'
  },
  colorVars: {
    '--accent': '#38BDF8',
    '--accent-foreground': '#101418',
    '--background': '#101418',
    '--border': '#3A5070',
    '--card': '#1A2030',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#DBEAFE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#101418',
    '--foreground': '#DBEAFE',
    '--hold-fill': '#38BDF8',
    '--input': '#3A5070',
    '--modal-bg': '#101418',
    '--modal-border': '#3A5070',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5070',
    '--muted-foreground': '#DBEAFE',
    '--nav-active': '#38BDF8',
    '--nav-bg': '#1A2030',
    '--popover': '#1A2030',
    '--popover-foreground': '#DBEAFE',
    '--primary': '#38BDF8',
    '--primary-foreground': '#101418',
    '--ring': '#38BDF8',
    '--secondary': '#3A5070',
    '--secondary-foreground': '#DBEAFE',
    '--streak': '#38BDF8',
    '--success': '#22c55e',
    '--success-foreground': '#101418',
    '--xp': '#38BDF8',
    '--xp-bg': '#1A2030'
  },
  resolvedVars: {
    '--accent': '#38BDF8',
    '--accent-foreground': '#101418',
    '--accent-foreground-hsl': '210 20% 8%',
    '--accent-foreground-oklch': 'from #101418 l c h',
    '--accent-hsl': '198 93% 60%',
    '--accent-oklch': 'from #38BDF8 l c h',
    '--background': '#101418',
    '--background-hsl': '210 20% 8%',
    '--background-oklch': 'from #101418 l c h',
    '--border': '#3A5070',
    '--border-hsl': '216 32% 33%',
    '--border-oklch': 'from #3A5070 l c h',
    '--border-w': '1px',
    '--card': '#1A2030',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#DBEAFE',
    '--card-foreground-hsl': '214 95% 93%',
    '--card-foreground-oklch': 'from #DBEAFE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '224 30% 15%',
    '--card-oklch': 'from #1A2030 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#101418',
    '--destructive-foreground-hsl': '210 20% 8%',
    '--destructive-foreground-oklch': 'from #101418 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#DBEAFE',
    '--foreground-hsl': '214 95% 93%',
    '--foreground-oklch': 'from #DBEAFE l c h',
    '--hold-fill': '#38BDF8',
    '--hold-fill-hsl': '198 93% 60%',
    '--hold-fill-oklch': 'from #38BDF8 l c h',
    '--input': '#3A5070',
    '--input-hsl': '216 32% 33%',
    '--input-oklch': 'from #3A5070 l c h',
    '--modal-bg': '#101418',
    '--modal-bg-hsl': '210 20% 8%',
    '--modal-bg-oklch': 'from #101418 l c h',
    '--modal-border': '#3A5070',
    '--modal-border-hsl': '216 32% 33%',
    '--modal-border-oklch': 'from #3A5070 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5070',
    '--muted-foreground': '#DBEAFE',
    '--muted-foreground-hsl': '214 95% 93%',
    '--muted-foreground-oklch': 'from #DBEAFE l c h',
    '--muted-hsl': '216 32% 33%',
    '--muted-oklch': 'from #3A5070 l c h',
    '--nav-active': '#38BDF8',
    '--nav-active-hsl': '198 93% 60%',
    '--nav-active-oklch': 'from #38BDF8 l c h',
    '--nav-bg': '#1A2030',
    '--nav-bg-hsl': '224 30% 15%',
    '--nav-bg-oklch': 'from #1A2030 l c h',
    '--popover': '#1A2030',
    '--popover-foreground': '#DBEAFE',
    '--popover-foreground-hsl': '214 95% 93%',
    '--popover-foreground-oklch': 'from #DBEAFE l c h',
    '--popover-hsl': '224 30% 15%',
    '--popover-oklch': 'from #1A2030 l c h',
    '--primary': '#38BDF8',
    '--primary-foreground': '#101418',
    '--primary-foreground-hsl': '210 20% 8%',
    '--primary-foreground-oklch': 'from #101418 l c h',
    '--primary-hsl': '198 93% 60%',
    '--primary-oklch': 'from #38BDF8 l c h',
    '--radius': '10px',
    '--ring': '#38BDF8',
    '--ring-hsl': '198 93% 60%',
    '--ring-oklch': 'from #38BDF8 l c h',
    '--secondary': '#3A5070',
    '--secondary-foreground': '#DBEAFE',
    '--secondary-foreground-hsl': '214 95% 93%',
    '--secondary-foreground-oklch': 'from #DBEAFE l c h',
    '--secondary-hsl': '216 32% 33%',
    '--secondary-oklch': 'from #3A5070 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#38BDF8',
    '--streak-hsl': '198 93% 60%',
    '--streak-oklch': 'from #38BDF8 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#101418',
    '--success-foreground-hsl': '210 20% 8%',
    '--success-foreground-oklch': 'from #101418 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(198 93% 60% / 0.15)',
    '--xp': '#38BDF8',
    '--xp-bg': '#1A2030',
    '--xp-bg-hsl': '224 30% 15%',
    '--xp-bg-oklch': 'from #1A2030 l c h',
    '--xp-hsl': '198 93% 60%',
    '--xp-oklch': 'from #38BDF8 l c h'
  }
}
